<div class="background-signing"></div>

<div class="overlay">

  <div class="login-card">

    <div class="login-left">
      <div class="login-area">
        <img *ngIf="dataManager.brandingReady && dataManager.loginlogo" 
             [src]="dataManager.loginlogo" 
             alt="Logo" class="login-logo" />
      </div>
    </div>

    <div class="login-right">

      <ng-container *ngIf="topErrorMessage">
        <div *ngFor="let obj of keys1">
          <div *ngFor="let value of obj">
            <p class="error">{{ value }}</p>
          </div>
        </div>
      </ng-container>
      <div class="error mb-2" *ngIf="!topErrorMessage">{{ errorMsg }}</div>

      <h4 class="heading2">Reset Password</h4>

      <div class="form-group">
        <label class="l_label" for="password">Password:</label>
        <input type="password" id="password" class="form-control"
               placeholder="********" [(ngModel)]="password"
               (keydown)="onKeydown($event)" required>
      </div>

      <div class="form-group">
        <label class="l_label" for="password_confirmation">Confirm Password:</label>
        <input type="password" id="password_confirmation" class="form-control"
               placeholder="********" [(ngModel)]="password_confirmation"
               (keydown)="onKeydown($event)" required>
      </div>

      <button class="bt_signin" [disabled]="loadFlag" (click)="resetpass()">
        Reset Password
        <i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i>
      </button>

      <div class="privacy-links mt-4" *ngIf="dataManager.brandingReady && dataManager.showPrivacyLinks">
        <a href="https://www.payarc.com/privacy-policy" target="_blank">Privacy Policy</a>
        <span>|</span>
        <a href="https://www.payarc.com/company/terms-and-conditions" target="_blank">Terms & Conditions</a>
      </div>

    </div>
  </div>
</div>